import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  button: {
    width: '100%'
  },
  container: {
    padding: '10px 15px'
  }
})

export default useStyles
